/**
 * Put a saved record back into a list without losing what only the LIST knew.
 *
 * Directory rows come from aggregate endpoints that add fields the stored
 * document does not have: each vendor's `sections` with their products (the
 * product counts), outlets, open state. A save answers with the stored
 * document alone, so replacing the row with it dropped those fields and the
 * Retailers & Wholesalers list showed "0 / 0" products after every edit until
 * a reload (reported 1 Nov 2026). Saved fields win; list-only fields stay.
 */
export const mergeSavedRow = (row, saved) => ({ ...row, ...saved });
